import { AlertTypes } from '../plugins/alerts_types'
import { notification } from '../plugins/helpers'

export default {
  methods: {
    async checarAlocacaoCota (id_pedido) {
      await this.$http.post('/contrato/atualiza_alocacao', { id_pedido }).then(async (response) => {
        notification(AlertTypes.SUCCESS, response.data.msg)
      }).catch(() => {
        notification(AlertTypes.ERROR, 'Ocorreu um erro ao verificar o status da alocação! Tente novamente em instantes.')
      })
    }
  }
}
